"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find-index");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.set");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index");

var _reactPager = _interopRequireDefault(require("@pcty/react-pager"));

var _reverse = _interopRequireDefault(require("@pcty/utils-commonjs/array/reverse"));

var _get = _interopRequireDefault(require("@pcty/utils-commonjs/object/get"));

var _removeKeys = _interopRequireDefault(require("@pcty/utils-commonjs/object/removeKeys"));

var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

var _lodash = _interopRequireDefault(require("lodash.flatmap"));

var _lodash2 = _interopRequireDefault(require("lodash.isequal"));

var _lodash3 = _interopRequireDefault(require("lodash.sortby"));

var _uuid = _interopRequireDefault(require("uuid"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var PctyBindableGrid = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(PctyBindableGrid, _React$Component);

  var _super = _createSuper(PctyBindableGrid);

  function PctyBindableGrid(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PctyBindableGrid);
    _this = _super.call(this, props);
    _this.onClickGoToPage = _this.onClickGoToPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.sortHandler = _this.sortHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkHandler = _this.checkHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkAllHandler = _this.checkAllHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.recursiveCloneChildren = _this.recursiveCloneChildren.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyUpHandler = _this.onKeyUpHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.insertToSelected = _this.insertToSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeFromSelected = _this.removeFromSelected.bind((0, _assertThisInitialized2.default)(_this));
    var sorting = {
      keys: props.sortKeys,
      direction: props.sortDirection
    };
    var data = doSort(props.data, sorting);
    var headerRow = getHeaderRow(props.children);

    if (!!headerRow) {
      headerRow = /*#__PURE__*/_react.default.cloneElement(headerRow, _objectSpread(_objectSpread({}, headerRow.props), {}, {
        children: _this.recursiveCloneChildren(headerRow.props.children, sorting, 0, data.length),
        disabled: _this.props.disabled || (0, _isNotNullOrEmpty.default)(_this.props.editId)
      }));
    }

    var page = 1;
    var numOfPages = Math.ceil(data.length / props.pageSize);

    if (props.page > numOfPages) {
      page = numOfPages === 0 ? 1 : numOfPages;
    } else {
      page = props.page;
    }

    _this.state = {
      props: props,
      headerRow: headerRow,
      templateRow: getTemplateRow(props.children),
      children: getNonRowChildren(props.children),
      pager: {
        page: page,
        pageSize: props.pageSize
      },
      data: data,
      displayedData: getDisplayedData(data, page, props.pageSize),
      sorting: sorting,
      selected: props.selected,
      footerActions: getFooterActions(props.children, props.disabled, props.editId),
      headerActions: getHeaderActions(props.children, props.disabled, props.editId),
      pctyGridProps: getPctyGridProps(props),
      activeIndexes: props.defaultActiveIndexes,
      dividerKey: props.dividerKey,
      renderZeroState: props.renderZeroState,
      recursiveCloneChildren: function recursiveCloneChildren(children, sorting, selectedCount, dataCount, rootIndex) {
        return _this.recursiveCloneChildren(children, sorting, selectedCount, dataCount, rootIndex);
      }
    };
    _this.shiftDown = false;
    _this.lastSelection = {
      id: null,
      insert: true
    };
    return _this;
  }

  (0, _createClass2.default)(PctyBindableGrid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.shiftClickSelections) {
        document.addEventListener('keydown', this.onKeyDownHandler);
        document.addEventListener('keyup', this.onKeyUpHandler);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.onKeyDownHandler);
      document.removeEventListener('keyup', this.onKeyUpHandler);
    }
  }, {
    key: "onKeyDownHandler",
    value: function onKeyDownHandler(e) {
      if (e.keyCode === 16 || e.key === 'Shift') {
        this.shiftDown = true;
      }
    }
  }, {
    key: "onKeyUpHandler",
    value: function onKeyUpHandler(e) {
      if (e.keyCode === 16 || e.key === 'Shift') {
        this.shiftDown = false;
        this.lastSelection = {
          id: null,
          insert: true
        };
      }
    }
  }, {
    key: "sortHandler",
    value: function sortHandler(keys) {
      var data = this.state.data;
      var direction = 'asc';

      if (this.state.sorting.keys.join(',') === keys.join(',')) {
        data = (0, _reverse.default)(data);
        direction = this.state.sorting.direction === 'desc' ? 'asc' : 'desc';
      } else {
        data = (0, _lodash3.default)(this.state.data, keys);
      }

      var sorting = {
        keys: keys,
        direction: direction
      };
      var headerRow = this.state.headerRow;

      if (!!headerRow) {
        headerRow = /*#__PURE__*/_react.default.cloneElement(headerRow, _objectSpread(_objectSpread({}, headerRow.props), {}, {
          children: this.recursiveCloneChildren(headerRow.props.children, sorting, this.state.selected.length, this.state.data.length)
        }));
      }

      this.setState({
        headerRow: headerRow,
        data: data,
        displayedData: getDisplayedData(data, 1, this.props.pageSize),
        sorting: sorting,
        pager: {
          page: 1,
          pageSize: this.props.pageSize
        },
        activeIndexes: this.props.activeIndexes
      });
      this.props.onSortChange(sorting);
      this.props.onActiveIndexesChange(this.props.activeIndexes);
    }
  }, {
    key: "checkHandler",
    value: function checkHandler(item, onChange) {
      var _this2 = this;

      var selected = (0, _toConsumableArray2.default)(this.state.selected); // Shift + Click

      if (this.shiftDown && !!this.lastSelection.id) {
        var remove = !this.lastSelection.insert && (0, _isNotNullOrEmpty.default)(this.state.selected) && this.state.selected.findIndex(function (x) {
          return x[_this2.props.primaryKey] === item[_this2.props.primaryKey];
        }) >= 0;
        var firstIndex = (0, _isNotNullOrEmpty.default)(this.state.displayedData) && this.state.displayedData.findIndex(function (x) {
          return x[_this2.props.primaryKey] === _this2.lastSelection.id;
        });
        var lastIndex = (0, _isNotNullOrEmpty.default)(this.state.displayedData) && this.state.displayedData.findIndex(function (x) {
          return x[_this2.props.primaryKey] === item[_this2.props.primaryKey];
        });
        var startIndex = Math.min(firstIndex, lastIndex);
        var endIndex = Math.max(firstIndex, lastIndex);

        if (remove) {
          if (startIndex === firstIndex) {
            startIndex = startIndex + 1;
          } else {
            endIndex = endIndex - 1;
          }
        }

        for (var i = startIndex; i <= endIndex; i++) {
          if (remove) {
            selected = this.removeFromSelected(this.state.displayedData[i], selected);
          } else {
            selected = this.insertToSelected(this.state.displayedData[i], selected, remove);
          }
        }

        this.shiftDown = false;
      } else {
        selected = this.insertToSelected(item, this.state.selected, true);
      }

      var headerRow = this.state.headerRow;

      if (!!headerRow) {
        headerRow = /*#__PURE__*/_react.default.cloneElement(headerRow, _objectSpread(_objectSpread({}, headerRow.props), {}, {
          children: this.recursiveCloneChildren(headerRow.props.children, this.state.sorting, selected.length, this.state.data.length)
        }));
      }

      this.setState({
        headerRow: headerRow,
        selected: selected
      }, function () {
        return onChange(_this2.state.selected);
      });
    }
  }, {
    key: "insertToSelected",
    value: function insertToSelected(item, selected, removeIfSelected) {
      var _this3 = this;

      if ((0, _isNotNullOrEmpty.default)(selected) && selected.findIndex(function (x) {
        return x[_this3.props.primaryKey] === item[_this3.props.primaryKey];
      }) >= 0) {
        if (removeIfSelected) {
          selected = selected.filter(function (x) {
            return x[_this3.props.primaryKey] !== item[_this3.props.primaryKey];
          });
          this.lastSelection = {
            id: item[this.props.primaryKey],
            insert: false
          };
        }
      } else {
        selected = [].concat((0, _toConsumableArray2.default)(selected), [item]);
        this.lastSelection = {
          id: item[this.props.primaryKey],
          insert: true
        };
      }

      return selected;
    }
  }, {
    key: "removeFromSelected",
    value: function removeFromSelected(item, selected) {
      var _this4 = this;

      this.lastSelection = {
        id: item[this.props.primaryKey],
        insert: false
      };
      return selected.filter(function (x) {
        return x[_this4.props.primaryKey] !== item[_this4.props.primaryKey];
      });
    }
  }, {
    key: "checkAllHandler",
    value: function checkAllHandler(onChange) {
      var _this5 = this;

      var selected = null;

      if (this.state.selected.length >= this.state.data.length) {
        selected = [];
      } else {
        selected = (0, _toConsumableArray2.default)(this.state.data);
      }

      var headerRow = this.state.headerRow;

      if (!!headerRow) {
        headerRow = /*#__PURE__*/_react.default.cloneElement(headerRow, _objectSpread(_objectSpread({}, headerRow.props), {}, {
          children: this.recursiveCloneChildren(headerRow.props.children, this.state.sorting, selected.length, this.state.data.length)
        }));
      }

      this.setState({
        headerRow: headerRow,
        selected: selected
      }, function () {
        return onChange(_this5.state.selected);
      });
    }
  }, {
    key: "recursiveCloneChildren",
    value: function recursiveCloneChildren(children, sorting, selectedCount, dataCount, rootIndex) {
      var _this6 = this;

      if (children) {
        var offset = children.length && children[0].props && !children[0].props.children ? 1 : 0;
        return _react.default.Children.map(children, function (child, index) {
          var automationId = _this6.props.automationId;
          var colIndex = typeof rootIndex === 'number' ? rootIndex : index - offset;
          var childProps = {};

          if ( /*#__PURE__*/_react.default.isValidElement(child)) {
            if (!!child.props.__TYPE && child.props.__TYPE === 'PctyFieldSorter') {
              childProps = _objectSpread(_objectSpread({
                automationId: automationId ? "".concat(automationId, "-sorter-c").concat(colIndex) : null
              }, child.props), {}, {
                onClick: function onClick() {
                  return _this6.sortHandler(child.props.sortKeys);
                },
                sortDirection: sorting.keys.join(',') === child.props.sortKeys.join(',') ? sorting.direction : ''
              });
            } else if (!!child.props.__TYPE && child.props.__TYPE === 'PctyGridHeaderRowCheckboxCell') {
              childProps = _objectSpread(_objectSpread({
                automationId: automationId ? "".concat(automationId, "-checkbox-toggleall") : null
              }, child.props), {}, {
                render: function render() {
                  return _this6.checkAllHandler(child.props.onChange);
                },
                checked: selectedCount >= dataCount && dataCount > 0,
                indeterminate: selectedCount > 0 && selectedCount < dataCount,
                disabled: dataCount <= 0
              });
            } else {
              childProps = _objectSpread({
                automationId: automationId && colIndex >= 0 ? "".concat(automationId, "-header-c").concat(colIndex) : null
              }, child.props);
            }
          }

          if (child.props) {
            childProps.children = _this6.recursiveCloneChildren(child.props.children, sorting, selectedCount, dataCount, colIndex);
            return /*#__PURE__*/_react.default.cloneElement(child, childProps);
          }

          return child;
        }).filter(function (x) {
          return !x || !x.props || !x.props.hidden;
        });
      }
    }
  }, {
    key: "onClickGoToPage",
    value: function onClickGoToPage(id, page) {
      this.setState({
        pager: _objectSpread(_objectSpread({}, this.state.pager), {}, {
          page: page
        }),
        displayedData: getDisplayedData(this.state.data, page, this.props.pageSize),
        activeIndexes: this.props.activeIndexes
      });
      this.props.onPageChange(page);
      this.props.onActiveIndexesChange(this.props.activeIndexes);
    }
  }, {
    key: "expandToggleClicked",
    value: function expandToggleClicked(item, index, defaultAction) {
      var activeIndexes = (0, _toConsumableArray2.default)(this.state.activeIndexes);

      if (activeIndexes.indexOf(index) < 0) {
        activeIndexes.push(index);
      } else {
        activeIndexes.splice(activeIndexes.indexOf(index), 1);
      }

      this.setState({
        activeIndexes: activeIndexes
      });

      if (defaultAction) {
        defaultAction(item, index);
      }

      this.props.onActiveIndexesChange(activeIndexes);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderPagerHeader(), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement(_index.PctyGrid, (0, _extends2.default)({}, this.state.pctyGridProps, {
        renderZeroState: this.state.renderZeroState
      }), this.state.headerRow, this.state.children, (0, _lodash.default)(this.state.displayedData, function (item, index) {
        return _this7.renderRows(item, index);
      })))), this.renderPager());
    }
  }, {
    key: "renderRows",
    value: function renderRows(item, index) {
      var _this8 = this;

      var _this$props = this.props,
          alternateRowStyle = _this$props.alternateRowStyle,
          automationId = _this$props.automationId;
      var _this$state = this.state,
          templateRow = _this$state.templateRow,
          displayedData = _this$state.displayedData,
          dividerKey = _this$state.dividerKey;

      var rowProps = _objectSpread({}, templateRow.props);

      var rows = [];
      var cols = (Array.isArray(rowProps.children) ? rowProps.children : [rowProps.children]).filter(function (x) {
        return !x.props.hidden;
      });

      if (alternateRowStyle && index % 2 === 1) {
        rowProps = _objectSpread(_objectSpread({}, rowProps), {}, {
          className: ((rowProps.className || '') + ' pcty-grid-row-alt').trim()
        });
      }

      if (this.props.disabled || (0, _isNotNullOrEmpty.default)(this.props.editId) && item[this.props.primaryKey] !== this.props.editId) {
        rowProps = _objectSpread(_objectSpread({}, rowProps), {}, {
          rowType: 'disabled'
        });
      }

      if (item[this.props.primaryKey] === this.props.editId) {
        rowProps = _objectSpread(_objectSpread({}, rowProps), {}, {
          rowType: 'editing'
        });
      }

      if (dividerKey) {
        var currentRowKey = (0, _get.default)(item, dividerKey);
        var previousRowKey = index > 0 && (0, _get.default)(displayedData[index - 1], dividerKey);

        if (currentRowKey !== previousRowKey) {
          rows.push( /*#__PURE__*/_react.default.createElement(_index.PctyDividerGridRow, {
            columnSpan: cols.length,
            key: _uuid.default.v4(),
            label: this.props.dividerLabel(currentRowKey)
          }));
        }
      }

      if (rowProps.__TYPE === 'PctyExpandableGridRow') {
        rowProps.isExpanded = this.state.activeIndexes.some(function (x) {
          return x === index;
        });

        rowProps.onClick = function () {
          return _this8.expandToggleClicked(item, index, templateRow.props.onClick);
        };

        rowProps.columnSpan = cols.length;
        rowProps.automationId = automationId ? "".concat(automationId, "-toggle-r").concat(index) : null;
        rows.push( /*#__PURE__*/_react.default.createElement(_index.PctyExpandableGridRow, (0, _extends2.default)({}, rowProps, {
          key: _uuid.default.v4()
        }), cols.map(function (x, i) {
          return _this8.renderRowChild(x, item, index, i);
        })));
      } else {
        rows.push( /*#__PURE__*/_react.default.createElement(_index.PctyGridRow, (0, _extends2.default)({}, rowProps, {
          key: _uuid.default.v4()
        }), cols.map(function (x, i) {
          return _this8.renderRowChild(x, item, index, i);
        })));
      }

      return rows;
    }
  }, {
    key: "renderRowChild",
    value: function renderRowChild(x, item, rowIndex, colIndex) {
      var _this9 = this;

      var automationId = this.props.automationId;

      if (automationId && x.props.__TYPE) {
        switch (x.props.__TYPE) {
          case 'PctyGridRowCheckboxCell':
            automationId += "-checkbox-r".concat(rowIndex);
            break;

          case 'PctyExpandable':
            automationId += "-details-r".concat(rowIndex);
            break;

          default:
            automationId += "-cell-r".concat(rowIndex, "c").concat(colIndex);
        }
      }

      var childProps = _objectSpread(_objectSpread({}, x.props), {}, {
        key: _uuid.default.v4(),
        automationId: automationId
      });

      if (!!x.props.__TYPE && x.props.__TYPE === 'PctyGridRowCheckboxCell') {
        childProps = _objectSpread(_objectSpread({}, childProps), {}, {
          render: function render() {
            return _this9.checkHandler(item, x.props.onChange);
          },
          checked: (0, _isNotNullOrEmpty.default)(this.state.selected) && this.state.selected.findIndex(function (z) {
            return z[_this9.props.primaryKey] === item[_this9.props.primaryKey];
          }) >= 0,
          __disabled: this.props.disabled || (0, _isNotNullOrEmpty.default)(this.props.editId)
        });
      } else if (!!x.props.__TYPE && x.props.__TYPE === 'PctyGridRowCell') {
        childProps = _objectSpread(_objectSpread({}, childProps), {}, {
          __editing: (0, _isNotNullOrEmpty.default)(this.props.editId) && item[this.props.primaryKey] === this.props.editId,
          __renderState: this.props.renderState
        });
      }

      return /*#__PURE__*/_react.default.cloneElement(x, childProps, item);
    }
  }, {
    key: "renderPager",
    value: function renderPager() {
      var _this$props2 = this.props,
          automationId = _this$props2.automationId,
          disabled = _this$props2.disabled,
          editId = _this$props2.editId;
      var _this$state2 = this.state,
          data = _this$state2.data,
          footerActions = _this$state2.footerActions,
          pager = _this$state2.pager;
      var displayPager = data.length > pager.pageSize && pager.pageSize !== -1;
      if (!displayPager && !footerActions || !data.length) return null;

      if (!displayPager && !!footerActions) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-12"
        }, footerActions));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row-float-fill pcty-flex"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-fluid pcty-padding-right"
      }, footerActions), /*#__PURE__*/_react.default.createElement(_reactPager.default, {
        automationId: automationId ? "".concat(automationId, "-pager") : null,
        disabled: disabled || (0, _isNotNullOrEmpty.default)(editId),
        id: "myPager",
        itemCount: this.state.data.length,
        numberOfVisiblePages: 5,
        onClickGoToPage: this.onClickGoToPage,
        page: this.state.pager.page,
        pageSize: this.state.pager.pageSize
      }))));
    }
  }, {
    key: "renderPagerHeader",
    value: function renderPagerHeader() {
      var _this$props3 = this.props,
          automationId = _this$props3.automationId,
          disabled = _this$props3.disabled,
          topPager = _this$props3.topPager,
          editId = _this$props3.editId;
      var _this$state3 = this.state,
          data = _this$state3.data,
          headerActions = _this$state3.headerActions,
          pager = _this$state3.pager;
      var displayPager = data.length > pager.pageSize && pager.pageSize !== -1;
      if (!displayPager && !headerActions || !data.length) return null;

      if ((!displayPager || !topPager) && !!headerActions) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-row pcty-padding-bottom"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-12"
        }, headerActions));
      }

      if (!topPager) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row-float-fill pcty-flex"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-fluid pcty-padding-right"
      }, headerActions), /*#__PURE__*/_react.default.createElement(_reactPager.default, {
        automationId: automationId ? "".concat(automationId, "-pager-header") : null,
        disabled: disabled || (0, _isNotNullOrEmpty.default)(editId),
        id: "myPager-header",
        itemCount: this.state.data.length,
        numberOfVisiblePages: 5,
        onClickGoToPage: this.onClickGoToPage,
        page: this.state.pager.page,
        pageSize: this.state.pager.pageSize
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var sorting = {
        keys: props.sortKeys,
        direction: props.sortDirection
      };

      if (props.maintainSortOnNewData) {
        sorting = _objectSpread({}, state.sorting);
      }

      var processHeaderRow = function processHeaderRow(data, selectedCount) {
        var headerRow = getHeaderRow(props.children);

        if (!!headerRow) {
          headerRow = /*#__PURE__*/_react.default.cloneElement(headerRow, _objectSpread(_objectSpread({}, headerRow.props), {}, {
            children: state.recursiveCloneChildren(headerRow.props.children, sorting, selectedCount, data.length),
            disabled: props.disabled || (0, _isNotNullOrEmpty.default)(props.editId)
          }));
        }

        return headerRow;
      };

      if (!(0, _lodash2.default)(state.props.data, props.data)) {
        var returnSelected = props.maintainSelectedOnNewData ? (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(state.selected), (0, _toConsumableArray2.default)(props.selected)))) : props.selected;
        var data = doSort(props.data, sorting);

        var _headerRow = processHeaderRow(data, 0);

        var page = 1;

        if (props.maintainPagingOnNewData) {
          var numOfPages = Math.ceil(props.data.length / props.pageSize);

          if (state.pager.page > numOfPages) {
            page = numOfPages === 0 ? 1 : numOfPages;
          } else {
            page = state.pager.page;
          }
        }

        props.onPageChange(page);
        props.onActiveIndexesChange(props.activeIndexes);
        return {
          props: props,
          headerRow: _headerRow,
          data: data,
          displayedData: getDisplayedData(data, page, props.pageSize),
          pager: {
            page: page,
            pageSize: props.pageSize
          },
          activeIndexes: props.activeIndexes,
          selected: returnSelected,
          sorting: sorting,
          renderZeroState: props.renderZeroState,
          footerActions: getFooterActions(props.children, props.disabled, props.editId),
          headerActions: getHeaderActions(props.children, props.disabled, props.editId)
        };
      }

      if (!(0, _lodash2.default)(state.props.activeIndexes, props.activeIndexes)) {
        var _headerRow2 = processHeaderRow(props.data, state.selected.length);

        return {
          headerRow: _headerRow2,
          activeIndexes: props.activeIndexes,
          props: props,
          footerActions: getFooterActions(props.children, props.disabled, props.editId),
          headerActions: getHeaderActions(props.children, props.disabled, props.editId)
        };
      }

      if (!(0, _lodash2.default)(state.props.defaultActiveIndexes, props.defaultActiveIndexes)) {
        var _headerRow3 = processHeaderRow(props.data, state.selected.length);

        return {
          headerRow: _headerRow3,
          activeIndexes: props.defaultActiveIndexes,
          props: props,
          footerActions: getFooterActions(props.children, props.disabled, props.editId),
          headerActions: getHeaderActions(props.children, props.disabled, props.editId)
        };
      }

      var headerRow = processHeaderRow(props.data, state.selected.length);
      return {
        headerRow: headerRow,
        renderZeroState: props.renderZeroState,
        props: props,
        footerActions: getFooterActions(props.children, props.disabled, props.editId),
        headerActions: getHeaderActions(props.children, props.disabled, props.editId)
      };
    }
  }]);
  return PctyBindableGrid;
}(_react.default.Component);

var getPctyGridProps = function getPctyGridProps(props) {
  return (0, _removeKeys.default)(props, Object.keys(PctyBindableGrid.propTypes).filter(function (x) {
    return x !== 'children';
  }));
};

var doSort = function doSort(data, sorting) {
  if (sorting.keys.length <= 0 || !sorting.direction) return data;
  var sorted = (0, _lodash3.default)(data, sorting.keys);
  return sorting.direction === 'desc' ? (0, _reverse.default)(sorted) : sorted;
};

var getHeaderRow = function getHeaderRow(children) {
  var filtered = _react.default.Children.toArray(children).filter(function (child) {
    return child.props && child.props.__TYPE === 'PctyGridHeaderRow';
  });

  if (filtered.length > 0) return filtered[0];
  return null;
};

var getTemplateRow = function getTemplateRow(children) {
  var filtered = _react.default.Children.toArray(children).filter(function (child) {
    return child.props && (child.props.__TYPE === 'PctyGridRow' || child.props.__TYPE === 'PctyExpandableGridRow');
  });

  if (filtered.length > 0) return filtered[0];
  return null;
};

var getNonRowChildren = function getNonRowChildren(children) {
  return _react.default.Children.toArray(children).filter(function (child) {
    return !child.props || child.props.__TYPE !== 'PctyGridRow' && child.props.__TYPE !== 'PctyGridHeaderRow' && child.props.__TYPE !== 'PctyGridFooterActionArea' && child.props.__TYPE !== 'PctyExpandableGridRow';
  });
};

var getFooterActions = function getFooterActions(children, disabled, editId) {
  var filtered = _react.default.Children.toArray(children).filter(function (child) {
    return child.props && child.props.__TYPE === 'PctyGridFooterActionArea';
  });

  if (filtered.length <= 0) return null;
  return /*#__PURE__*/_react.default.cloneElement(filtered[0], _objectSpread(_objectSpread({}, filtered[0].props), {}, {
    disabled: disabled || (0, _isNotNullOrEmpty.default)(editId)
  }));
};

var getHeaderActions = function getHeaderActions(children, disabled, editId) {
  var filtered = _react.default.Children.toArray(children).filter(function (child) {
    return child.props && child.props.__TYPE === 'PctyGridHeaderActionArea';
  });

  if (filtered.length <= 0) return null;
  return /*#__PURE__*/_react.default.cloneElement(filtered[0], _objectSpread(_objectSpread({}, filtered[0].props), {}, {
    disabled: disabled || (0, _isNotNullOrEmpty.default)(editId)
  }));
};

var getDisplayedData = function getDisplayedData(data, page, pageSize) {
  if (pageSize <= -1) return data;

  var _page = page - 1; // because pages logically start with 1, but technically with 0


  return data.slice(_page * pageSize, (_page + 1) * pageSize);
};
/** INCLUDE CALLOUT: "&lt;PctyBindableGrid&gt; allows you to define a row template to generate and display data. Client-side paging and sorting are all handled for you. If you want server-side paging, use &lt;PctyBindableGridPage&gt;." */


PctyBindableGrid.propTypes = {
  /** INCLUDE FILE ./PctyGrid.jsx */

  /** The data to bind to the grid. */
  data: _propTypes.default.array.isRequired,

  /** The name of the property in your data objects that can uniquely identify an each item. */
  primaryKey: _propTypes.default.string.isRequired,

  /** The page to start on when the grid starts. */
  page: _propTypes.default.number,

  /** The number of items to display per page. */
  pageSize: _propTypes.default.number,
  selected: _propTypes.default.array,

  /** An array of property names to initially sort the data by. */
  sortKeys: _propTypes.default.array,

  /** The initial sort direction of the 'sortKeys' prop. */
  sortDirection: _propTypes.default.oneOf(['desc', 'asc', '']),
  children: _propTypes.default.node.isRequired,

  /** If true, the grid will support SHIFT + Click checkbox selections/deselections. */
  shiftClickSelections: _propTypes.default.bool,

  /** If true, the grid will keep track of previous selections even if that data is not in the new data set. This is helpful when a data set is filtered. */
  maintainSelectedOnNewData: _propTypes.default.bool,

  /** If true, the grid will keep track of the previous page and reselect it. If the page doesn't exist, it will go to the last page. */
  maintainPagingOnNewData: _propTypes.default.bool,

  /** If true, the grid will keep track of the previous sort and sort the new data based on it. */
  maintainSortOnNewData: _propTypes.default.bool,

  /** { description: "Callback function for when the sort order is changed.", validValues: "any function with (sorting) as a named param" } */
  onSortChange: _propTypes.default.func,

  /** { description: "Callback function for when the current page is changed.", validValues: "any function with (page) as a named param" } */
  onPageChange: _propTypes.default.func,

  /** { description: "", validValues: "any function with (activeIndexes) as a named param" } */
  onActiveIndexesChange: _propTypes.default.func,

  /** An array of currently active indexes (applies to PctyExpandable rows only) */
  activeIndexes: _propTypes.default.array,

  /** An array of the default active indexes (applies to PctyExpandable rows only) */
  defaultActiveIndexes: _propTypes.default.array,

  /** Key for the divider */
  dividerKey: _propTypes.default.string,

  /** Label for the divider */
  dividerLabel: _propTypes.default.func,

  /** Alternates the background colors of each row. */
  alternateRowStyle: _propTypes.default.bool,

  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes.default.string,

  /** Any additional/external state you want passed to your render functions (i.e. Redux state or scoped vars you might need). */
  renderState: _propTypes.default.any,

  /** Whether or not to include a pager above the grid. <blockquote><b>NOTE:</b> The next major release will not include this prop. The top pager will become a permanent fixture at that time.</blockquote> */
  topPager: _propTypes.default.bool,

  /** Whether or not the pagers and header actions are disabled */
  disabled: _propTypes.default.bool,

  /** { description: "The id of the row being edited.", type: "string, number" } */
  editId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyBindableGrid');
  }
};
PctyBindableGrid.defaultProps = {
  page: 1,
  pageSize: -1,
  selected: [],
  sortKeys: [],
  sortDirection: '',
  shiftClickSelections: false,
  maintainSelectedOnNewData: true,
  maintainPagingOnNewData: true,
  maintainSortOnNewData: true,
  onSortChange: function onSortChange() {},
  onPageChange: function onPageChange() {},
  onActiveIndexesChange: function onActiveIndexesChange() {},
  activeIndexes: [],
  defaultActiveIndexes: [],
  dividerKey: '',
  dividerLabel: function dividerLabel(x) {
    return x;
  },
  alternateRowStyle: false,
  topPager: false,
  disabled: false,
  editId: null,
  __TYPE: 'PctyBindableGrid'
};
var _default = PctyBindableGrid;
exports.default = _default;